var primaryColours = ['primary', 'primary_1', 'primary_2'];
var secondaryColours = ['secondary', 'secondary_1', 'secondary_2'];
var accent2Colours = ['accent-2', 'accent-2_1', 'accent-2_2'];
var accent3Colours = ['accent-3', 'accent-3_1', 'accent-3_2'];
var backgroundColours = ['background', 'background_1', 'background_2'];
var cardColours = ['cards', 'cards_1', 'cards_2'];
var borderColours = ['borders', 'borders_1', 'borders_2'];
var headingColours = ['headings', 'headings_1', 'headings_2'];
var textColours = ['text', 'text_1', 'text_2'];
var linkTextColours = ['link-text', 'link-text_1', 'link-text_2'];
var contrastTextColours = ['contrast-text', 'contrast-text_1', 'contrast-text_2'];
var validationColours = ['validation', 'validation_1', 'validation_2'];
var defaultColours = ['default', 'default_1', 'default_2'];
var rColours = ['r', 'r_1', 'r_2'];
var aColours = ['a', 'a_1', 'a_2'];
var gColours = ['g', 'g_1', 'g_2'];
var innerShadowColours = ['inner-shadow-colour', 'inner-shadow-colour_1'];
var outerShadowColours = ['outer-shadow-colour', 'outer-shadow-colour_1'];
export var randomColours = ['light', 'baby-blue', 'blue', 'lilac', 'grape', 'pink', 'bright-pink', 'berry', 'orange', 'honey', 'lime', 'apple', 'white', 'black', 'yellow'];
export var graphColours = ['grc_1', 'grc_2', 'grc_3', 'grc_4', 'grc_5', 'grc_6', 'grc_7', 'grc_8', 'grc_9', 'grc_10', 'grc_11', 'grc_12', 'grc_13', 'grc_14', 'grc_15'];
export var filteredGraphColours = ['grc_1', 'grc_2', 'grc_3', 'grc_4', 'grc_5', 'grc_6', 'grc_7', 'grc_8', 'grc_9', 'grc_10', 'grc_11', 'grc_12', 'grc_15'];
var backdropColour = 'backdrop';
export var themeColourGroups = [
    primaryColours,
    secondaryColours,
    accent2Colours,
    accent3Colours,
    backgroundColours,
    cardColours,
    headingColours,
    textColours,
    linkTextColours,
    contrastTextColours,
    validationColours,
    defaultColours,
    rColours,
    aColours,
    gColours,
    innerShadowColours,
    outerShadowColours,
    [backdropColour],
];
